import { render } from "./ContactView.vue?vue&type=template&id=cc12d654&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=cc12d654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc12d654"]])

export default __exports__